import * as React from "react";
const ViewLoaderContext = React.createContext(void 0);
export default ViewLoaderContext;
